import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box, // Import Box from @mui/material
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
import { Title } from '@mui/icons-material';
import Iconify from './Iconify'; // Import Iconify

import Page from './Page';
import Label from './Label';
import Scrollbar from './Scrollbar';
import SearchNotFound from './SearchNotFound';

import { HrconclaveListToolbar, HrconclaveListHead, HrconclaveMoreMenu } from '../sections/reports';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'year', label: 'Year', alignRight: false },
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'image', label: 'Image', alignRight: false },
  { id: 'form', label: 'Form', alignRight: false },
  { id: 'images', label: 'Images', alignRight: false },
  { id: 'eventdate', label: 'Event Date & Time', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  if (query) {
    filteredArray = filteredArray.filter((item) => {
      const searchTerm = query.toLowerCase();
      return (
        String(item.year).includes(searchTerm) || // Convert year to string for includes
        (item.image && item.image.toLowerCase().includes(searchTerm)) ||
        (item.form && item.form.toLowerCase().includes(searchTerm)) ||
        (item.images && item.images.some(img => img.toLowerCase().includes(searchTerm))) // Check if any image includes the search term
      );
    });
  }

  return filteredArray;
}

export default function Conclave({geturl,createmodel1url,createmodel2url,updateurl,deleteurl,head}) {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('year'); // Sort by year
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for Conclave
  const [conclaveData, setConclaveData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [year, setYear] = useState('');
  const [title, setTitle] = useState('');
  const [image, setImage] = useState('');
  const [form, setForms] = useState([]);
  const [newFormLink, setNewFormLink] = useState('');
  const [images, setImages] = useState([]);
  const [newImageLink, setNewImageLink] = useState('');
  const [modalType, setModalType] = useState('modal1'); // 'modal1' or 'modal2'
 const [eventDateTime, setEventDateTime] = useState('');

  // Fetch data from the server on component mount
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(geturl);
setConclaveData(response.data.data || response.data || []);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleViewItem = (item) => {
    setSelectedItem(item);
    setViewModalOpen(true);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = conclaveData.map((n) => n._id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleOpenModal = (id) => {
    setEditingId(id || null);
    setYear('');
    setTitle('');
    setImage('');
    setForms([]);
    setImages([]);
    setNewImageLink('');
  setEventDateTime('');
    setModalType('modal1'); // Default to modal1
    setOpenModal(true);

    if (id) {
      const item = conclaveData.find((item) => item._id === id);
      if (item) {
        setYear(item.year);
        setTitle(item.title);
        setImage(item.image || '');
        setForms(item.form || []);
        setImages([...item.images] || []);
if (item.eventDateTime) {
  const date = new Date(item.eventDateTime);
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000);
  setEventDateTime(localDate.toISOString().slice(0, 16));
} else {
  setEventDateTime('');
}
        if (item.image) {
          setModalType('modal1');
        } else {
          setModalType('modal2');
        }
      }
    }
  };

  const handleAddFormLink = () => {
    if (newFormLink.trim() !== '') {
      setForms([...form, newFormLink]);
      setNewFormLink('');
    }
  };

  const handleRemoveFormLink = (index) => {
    const updated = [...form];
    updated.splice(index, 1);
    setForms(updated);
  };


  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseViewModal = () => {
    setViewModalOpen(false);
    setSelectedItem(null);
  };

  const handleAddItem = async () => {
    try {
      let response;
      if (modalType === 'modal1') {
        response = await axios.post(createmodel1url, {
          title,
          year,
          image,
          form,
          eventDateTime
        });
      } else {
        response = await axios.post(createmodel2url, {
          title,
          year,
          images,
          form,
          eventDateTime
        });
      }

      fetchData();
      handleCloseModal();
    } catch (error) {
      console.error('Error adding data:', error);
    }
  };

  const handleUpdateItem = async () => {
    try {
      let payload;
      if (modalType === 'modal1') {
        payload = { title, year, image, form , eventDateTime};
      } else {
        payload = { title, year, images, form, eventDateTime };
      }
      await axios.put(`${updateurl}/${editingId}`, payload);  // Corrected endpoint
      fetchData();
      handleCloseModal();
    } catch (error) {
      console.error('Error updating data:', error);
    }
  };

  const handleDeleteItem = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        await axios.delete(`${deleteurl}/${id}`);  // Corrected endpoint
        fetchData();
      } catch (error) {
        console.error('Error deleting data:', error);
      }
    }
  };

  const handleAddImageLink = () => {
    if (newImageLink.trim() !== '') {
      setImages([...images, newImageLink]);
      setNewImageLink('');
    }
  };

  const handleRemoveImageLink = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - conclaveData.length) : 0;
const filteredConclaves = conclaveData.filter((item) => {
  const searchTerm = filterName.toLowerCase();
  return (
    String(item.year).includes(searchTerm) ||
    (item.image && item.image.toLowerCase().includes(searchTerm))
  );
});

  const isConclaveNotFound = filteredConclaves.length === 0;

  return (
    <Page title={head}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {head}
          </Typography>
          <Button variant="contained" onClick={() => handleOpenModal(null)} startIcon={<Iconify icon="eva:plus-fill" />}>
            New {head}
          </Button>
        </Stack>

        <Card>
          <HrconclaveListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <HrconclaveListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={conclaveData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredConclaves
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { _id } = row;

                      return (
                        <TableRow
                          hover
                          key={_id}
                          tabIndex={-1}
                          role="checkbox"

                        >
                          <TableCell padding="checkbox">
                            <IconButton aria-label="view" onClick={() => handleViewItem(row)}>
                              <Iconify icon="eva:eye-fill" />
                            </IconButton>
                          </TableCell>
                          <TableCell align="left">{row.year}</TableCell>
                          <TableCell align="left">{row.title}</TableCell>
                          <TableCell align="left">{row.image}</TableCell>
                          <TableCell align="left">
                            {Array.isArray(row.form) ? row.form.map((f, i) => (
                              <Typography key={i} variant="caption" display="block">
                                <a href={f} target="_blank" rel="noopener noreferrer">{f}</a>
                              </Typography>
                            )) : (
                              <Typography variant="caption" display="block">
                                <a href={row.form} target="_blank" rel="noopener noreferrer">{row.form}</a>
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell align="left">
                            {row.images && row.images.map((img, index) => (
                              <Typography key={index} variant="caption" display="block">
                                <a href={img} target="_blank" rel="noopener noreferrer">
                                  {img}
                                </a>
                              </Typography>
                            ))}
                          </TableCell>
                          <TableCell align="left">
                            {row.eventDateTime ? new Date(row.eventDateTime).toLocaleString() : 'N/A'}
                          </TableCell>
                          <TableCell align="right">
                            <HrconclaveMoreMenu
                              onEdit={() => handleOpenModal(_id)}
                              onDelete={() => handleDeleteItem(_id)}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isConclaveNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={conclaveData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{editingId ? `Edit ${head}` : `New ${head}`}</DialogTitle>
          <DialogContent>

            <FormControl fullWidth margin="dense">
              <InputLabel id="modal-type-label">Modal Type</InputLabel>
              <Select
                labelId="modal-type-label"
                id="modal-type-select"
                value={modalType}
                label="Modal Type"
                onChange={(e) => setModalType(e.target.value)}
              >
                <MenuItem value="modal1">Modal 1 (Title, Year, Image, Form)</MenuItem>
                <MenuItem value="modal2">Modal 2 (Title, Year, Images, Form)</MenuItem>
              </Select>
            </FormControl>

            <TextField
              margin="dense"
              label="Title"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />

            <TextField
              autoFocus
              margin="dense"
              label="Year"
              type="number"
              fullWidth
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
            <TextField
  margin="dense"
  label="Event Date & Time"
  type="datetime-local"
  fullWidth
  value={eventDateTime}
  onChange={(e) => setEventDateTime(e.target.value)}
  InputLabelProps={{
    shrink: true,
  }}
/>

            <Box sx={{ mt: 2 }}>
              <TextField
                label="Add Form Link"
                fullWidth
                value={newFormLink}
                onChange={(e) => setNewFormLink(e.target.value)}
              />
              <Button variant="outlined" onClick={handleAddFormLink} sx={{ mt: 1 }}>
                Add Form
              </Button>
            </Box>

            <Box sx={{ mt: 2 }}>
              {form.map((f, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography variant="body2">{f}</Typography>
                  <IconButton onClick={() => handleRemoveFormLink(index)}>
                    <Iconify icon="eva:trash-2-outline" />
                  </IconButton>
                </Box>
              ))}
            </Box>



            {modalType === 'modal1' && (
              <>
                <TextField
                  margin="dense"
                  label="Image URL"
                  type="text"
                  fullWidth
                  value={image}
                  onChange={(e) => setImage(e.target.value)}
                />

              </>
            )}

            {modalType === 'modal2' && (
              <>
                <Box sx={{ mt: 2 }}>
                  <TextField
                    label="Add Image Link"
                    type="text"
                    fullWidth
                    value={newImageLink}
                    onChange={(e) => setNewImageLink(e.target.value)}
                  />
                  <Button variant="outlined" onClick={handleAddImageLink} sx={{ mt: 1 }}>Add Link</Button>
                </Box>

                <Box sx={{ mt: 2 }}>
                  {images.map((img, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Typography variant="body2">{img}</Typography>
                      <IconButton onClick={() => handleRemoveImageLink(index)}>
                        <Iconify icon="eva:trash-2-outline" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              </>
            )}

          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editingId ? (
              <Button onClick={handleUpdateItem}>Update</Button>
            ) : (
              <Button onClick={handleAddItem}>Create</Button>
            )}
          </DialogActions>
        </Dialog>

        {/* View Modal */}
        <Dialog open={viewModalOpen} onClose={handleCloseViewModal}>
          <DialogTitle>{head} Details</DialogTitle>
          <DialogContent>
            {selectedItem && (
              <>
                <TextField
                  label="Year"
                  value={selectedItem.year}
                  margin="dense"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  label="Event Date & Time"
                  value={selectedItem.eventDateTime ? new Date(selectedItem.eventDateTime).toLocaleString() : 'N/A'}
                  margin="dense"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  variant="outlined"
                />
                <TextField
                  label="Title"
                  value={selectedItem.title}
                  InputProps={{ readOnly: true }}
                  fullWidth
                />

                {selectedItem.image && (
                  <TextField
                    label="Image URL"
                    value={selectedItem.image}
                    margin="dense"
                    InputProps={{
                      readOnly: true,
                    }}
                    fullWidth
                    variant="outlined"
                  />
                )}
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">Forms:</Typography>
                  {Array.isArray(selectedItem.form) ? selectedItem.form.map((f, i) => (
                    <Typography key={i} variant="body2">
                      <a href={f} target="_blank" rel="noopener noreferrer">{f}</a>
                    </Typography>
                  )) : (
                    <Typography variant="body2">
                      <a href={selectedItem.form} target="_blank" rel="noopener noreferrer">{selectedItem.form}</a>
                    </Typography>
                  )}
                </Box>
                {selectedItem.images && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle2">Images:</Typography>
                    {selectedItem.images.map((img, index) => (
                      <Typography key={index} variant="body2">
                        <a href={img} target="_blank" rel="noopener noreferrer">
                          {img}
                        </a>
                      </Typography>
                    ))}
                  </Box>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseViewModal}>Close</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}
